"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
require("core-js/modules/es.symbol.js");
require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.symbol.iterator.js");
require("core-js/modules/es.symbol.to-primitive.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.array.for-each.js");
require("core-js/modules/es.array.index-of.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.date.to-primitive.js");
require("core-js/modules/es.number.constructor.js");
require("core-js/modules/es.object.assign.js");
require("core-js/modules/es.object.define-properties.js");
require("core-js/modules/es.object.define-property.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
require("core-js/modules/es.object.get-own-property-descriptors.js");
require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.showToast = exports.dismissToast = exports.defaultToastStyle = exports["default"] = void 0;
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.join.js");
require("core-js/modules/es.array.map.js");
var _react = _interopRequireWildcard(require("react"));
var _reactToastify = require("react-toastify");
var _injectStyle = require("react-toastify/dist/inject-style.js");
var _core = require("../../core");
var _Button = _interopRequireDefault(require("../../core/Button"));
var _useMedia = _interopRequireDefault(require("../../hooks/useMedia"));
var _eero = require("../../theme/eero");
var _excluded = ["actionText"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function cov_gan9kb495() {
  var path = "/__w/code/code/js/packages/bricks/src/complex/Toast/Toast.tsx";
  var hash = "ada99a6ccde296fc963d6e155d201c47cb082905";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/complex/Toast/Toast.tsx",
    statementMap: {
      "0": {
        start: {
          line: 27,
          column: 54
        },
        end: {
          line: 35,
          column: 1
        }
      },
      "1": {
        start: {
          line: 67,
          column: 24
        },
        end: {
          line: 95,
          column: 1
        }
      },
      "2": {
        start: {
          line: 68,
          column: 20
        },
        end: {
          line: 68,
          column: 50
        }
      },
      "3": {
        start: {
          line: 74,
          column: 2
        },
        end: {
          line: 76,
          column: 9
        }
      },
      "4": {
        start: {
          line: 75,
          column: 4
        },
        end: {
          line: 75,
          column: 18
        }
      },
      "5": {
        start: {
          line: 78,
          column: 2
        },
        end: {
          line: 94,
          column: 4
        }
      },
      "6": {
        start: {
          line: 97,
          column: 98
        },
        end: {
          line: 114,
          column: 1
        }
      },
      "7": {
        start: {
          line: 101,
          column: 2
        },
        end: {
          line: 113,
          column: 11
        }
      },
      "8": {
        start: {
          line: 138,
          column: 28
        },
        end: {
          line: 138,
          column: 41
        }
      },
      "9": {
        start: {
          line: 147,
          column: 25
        },
        end: {
          line: 233,
          column: 1
        }
      },
      "10": {
        start: {
          line: 166,
          column: 16
        },
        end: {
          line: 166,
          column: 25
        }
      },
      "11": {
        start: {
          line: 168,
          column: 17
        },
        end: {
          line: 177,
          column: 3
        }
      },
      "12": {
        start: {
          line: 171,
          column: 45
        },
        end: {
          line: 171,
          column: 88
        }
      },
      "13": {
        start: {
          line: 173,
          column: 6
        },
        end: {
          line: 173,
          column: 58
        }
      },
      "14": {
        start: {
          line: 174,
          column: 4
        },
        end: {
          line: 176,
          column: 5
        }
      },
      "15": {
        start: {
          line: 175,
          column: 6
        },
        end: {
          line: 175,
          column: 26
        }
      },
      "16": {
        start: {
          line: 179,
          column: 37
        },
        end: {
          line: 182,
          column: 3
        }
      },
      "17": {
        start: {
          line: 184,
          column: 2
        },
        end: {
          line: 232,
          column: 4
        }
      },
      "18": {
        start: {
          line: 186,
          column: 6
        },
        end: {
          line: 213,
          column: 9
        }
      },
      "19": {
        start: {
          line: 191,
          column: 14
        },
        end: {
          line: 201,
          column: 16
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 67,
            column: 24
          },
          end: {
            line: 67,
            column: 25
          }
        },
        loc: {
          start: {
            line: 67,
            column: 30
          },
          end: {
            line: 95,
            column: 1
          }
        },
        line: 67
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 74,
            column: 12
          },
          end: {
            line: 74,
            column: 13
          }
        },
        loc: {
          start: {
            line: 74,
            column: 18
          },
          end: {
            line: 76,
            column: 3
          }
        },
        line: 74
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 97,
            column: 98
          },
          end: {
            line: 97,
            column: 99
          }
        },
        loc: {
          start: {
            line: 101,
            column: 2
          },
          end: {
            line: 113,
            column: 11
          }
        },
        line: 101
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 147,
            column: 25
          },
          end: {
            line: 147,
            column: 26
          }
        },
        loc: {
          start: {
            line: 165,
            column: 5
          },
          end: {
            line: 233,
            column: 1
          }
        },
        line: 165
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 168,
            column: 17
          },
          end: {
            line: 168,
            column: 18
          }
        },
        loc: {
          start: {
            line: 168,
            column: 23
          },
          end: {
            line: 177,
            column: 3
          }
        },
        line: 168
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 185,
            column: 4
          },
          end: {
            line: 185,
            column: 5
          }
        },
        loc: {
          start: {
            line: 186,
            column: 6
          },
          end: {
            line: 213,
            column: 9
          }
        },
        line: 186
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 190,
            column: 32
          },
          end: {
            line: 190,
            column: 33
          }
        },
        loc: {
          start: {
            line: 191,
            column: 14
          },
          end: {
            line: 201,
            column: 16
          }
        },
        line: 191
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 88,
            column: 22
          },
          end: {
            line: 88,
            column: 59
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 88,
            column: 34
          },
          end: {
            line: 88,
            column: 51
          }
        }, {
          start: {
            line: 88,
            column: 54
          },
          end: {
            line: 88,
            column: 59
          }
        }],
        line: 88
      },
      "1": {
        loc: {
          start: {
            line: 171,
            column: 45
          },
          end: {
            line: 171,
            column: 88
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 171,
            column: 45
          },
          end: {
            line: 171,
            column: 52
          }
        }, {
          start: {
            line: 171,
            column: 56
          },
          end: {
            line: 171,
            column: 88
          }
        }],
        line: 171
      },
      "2": {
        loc: {
          start: {
            line: 173,
            column: 6
          },
          end: {
            line: 173,
            column: 58
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 173,
            column: 6
          },
          end: {
            line: 173,
            column: 18
          }
        }, {
          start: {
            line: 173,
            column: 22
          },
          end: {
            line: 173,
            column: 58
          }
        }],
        line: 173
      },
      "3": {
        loc: {
          start: {
            line: 174,
            column: 4
          },
          end: {
            line: 176,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 174,
            column: 4
          },
          end: {
            line: 176,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 174
      },
      "4": {
        loc: {
          start: {
            line: 181,
            column: 15
          },
          end: {
            line: 181,
            column: 56
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 181,
            column: 15
          },
          end: {
            line: 181,
            column: 47
          }
        }, {
          start: {
            line: 181,
            column: 51
          },
          end: {
            line: 181,
            column: 56
          }
        }],
        line: 181
      },
      "5": {
        loc: {
          start: {
            line: 189,
            column: 11
          },
          end: {
            line: 202,
            column: 14
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 189,
            column: 11
          },
          end: {
            line: 189,
            column: 27
          }
        }, {
          start: {
            line: 190,
            column: 12
          },
          end: {
            line: 202,
            column: 14
          }
        }],
        line: 189
      },
      "6": {
        loc: {
          start: {
            line: 203,
            column: 11
          },
          end: {
            line: 211,
            column: 11
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 203,
            column: 11
          },
          end: {
            line: 203,
            column: 34
          }
        }, {
          start: {
            line: 204,
            column: 12
          },
          end: {
            line: 210,
            column: 14
          }
        }],
        line: 203
      },
      "7": {
        loc: {
          start: {
            line: 208,
            column: 26
          },
          end: {
            line: 208,
            column: 88
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 208,
            column: 57
          },
          end: {
            line: 208,
            column: 83
          }
        }, {
          start: {
            line: 208,
            column: 86
          },
          end: {
            line: 208,
            column: 88
          }
        }],
        line: 208
      },
      "8": {
        loc: {
          start: {
            line: 218,
            column: 25
          },
          end: {
            line: 218,
            column: 76
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 218,
            column: 43
          },
          end: {
            line: 218,
            column: 61
          }
        }, {
          start: {
            line: 218,
            column: 64
          },
          end: {
            line: 218,
            column: 76
          }
        }],
        line: 218
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "ada99a6ccde296fc963d6e155d201c47cb082905"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_gan9kb495 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_gan9kb495();
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var defaultToastStyle = exports.defaultToastStyle = (cov_gan9kb495().s[0]++, {
  backgroundColor: _eero.colors.neutrals100,
  boxShadow: _eero.shadows.z2,
  color: _eero.colors.neutrals0,
  fontFamily: _eero.fonts.sans,
  fontSize: _eero.fontSizesNamedWithUnits.s1,
  fontWeight: _eero.fontWeights.normal,
  lineHeight: _eero.lineHeightsWithUnits.s1
});

/**
 * Make sure this component is mounted once and only once at app root before
 * calling `showToast`.
 *
 * Toasts display brief, temporary notifications. They're meant to be noticed
 * without disrupting a user's experience or requiring an action to be taken.
 *
 * There are 2 kinds of toasts: informational toasts and global error toasts.
 *
 * Toast components should be rendered at the root of the application. The
 * contents and type of toast displayed is configured via the `showToast` method
 * in Toast.tsx. Because Toasts are manually triggered, look at
 * `Toast.example.tsx` in the codebase for a complete documentation of how a
 * Toast component can be used.
 *
 * Analytics
 *
 *
 * -------------
 *
 * Standard impression, click, and hover tracking are included for the action
 * buttons on the toast.
 *
 * Toast type variations
 * ------------------------------------------------------------------------------------------
 *
 * "info"
 *
 * "error"
 */
cov_gan9kb495().s[1]++;
var Toast = function Toast() {
  cov_gan9kb495().f[0]++;
  var isDesktop = (cov_gan9kb495().s[2]++, (0, _useMedia["default"])('(min-width: 645px)'));

  /**
   * Inject the toast styles once
   * @see https://fkhadra.github.io/react-toastify/how-to-style#inject-style-on-demand
   */
  cov_gan9kb495().s[3]++;
  (0, _react.useEffect)(function () {
    cov_gan9kb495().f[1]++;
    cov_gan9kb495().s[4]++;
    (0, _injectStyle.injectStyle)();
  }, []);
  cov_gan9kb495().s[5]++;
  return /*#__PURE__*/_react["default"].createElement(_reactToastify.ToastContainer, {
    autoClose: 5000,
    bodyStyle: {
      display: 'block',
      padding: 0
    },
    hideProgressBar: true,
    pauseOnHover: true,
    position: "top-center",
    style: {
      maxWidth: '100%',
      width: '645px',
      borderRadius: isDesktop ? (cov_gan9kb495().b[0][0]++, _eero.radii.semiRounded) : (cov_gan9kb495().b[0][1]++, '0px'),
      overflow: 'hidden',
      padding: 0
    },
    transition: _reactToastify.Slide
  });
};
cov_gan9kb495().s[6]++;
var ToastButton = function ToastButton(_ref) {
  var actionText = _ref.actionText,
    props = _objectWithoutProperties(_ref, _excluded);
  cov_gan9kb495().f[2]++;
  cov_gan9kb495().s[7]++;
  return /*#__PURE__*/_react["default"].createElement(_Button["default"], _extends({
    variant: "link",
    size: "sm",
    width: "initial",
    color: "neutrals0",
    fontSize: "s0",
    fontWeight: "semibold",
    pl: 3,
    pr: 3
  }, props), actionText);
};

// type of the `options` prop to be passed to `showToast`

/**
 * Dismiss a toast programmaticaly
 */
var dismissToast = exports.dismissToast = (cov_gan9kb495().s[8]++, _reactToastify.toast.dismiss);

/**
 * Show a toast with the specified type, content, and actions
 * @param type - 'info' | 'error'
 * @param content - the content of the toast
 * @param analyticsName - Name of the toast in analytics events, should be unique within the app
 * @param options - options to customize the toast
 */
cov_gan9kb495().s[9]++;
var showToast = exports.showToast = function showToast(type, content, analyticsName, options) {
  var _options$toastOptions;
  cov_gan9kb495().f[3]++;
  var toastId = (cov_gan9kb495().s[10]++, undefined);
  cov_gan9kb495().s[11]++;
  var onOpen = function onOpen() {
    cov_gan9kb495().f[4]++;
    // `getElementById` is called first because toastId might start with a number, which
    // causes querySelector(`#${toastID} button`) to fail
    var toastElement = (cov_gan9kb495().s[12]++, (cov_gan9kb495().b[1][0]++, toastId) && (cov_gan9kb495().b[1][1]++, document.getElementById(toastId)));
    var firstButton = (cov_gan9kb495().s[13]++, (cov_gan9kb495().b[2][0]++, toastElement) && (cov_gan9kb495().b[2][1]++, toastElement.querySelector('button')));
    cov_gan9kb495().s[14]++;
    if (firstButton) {
      cov_gan9kb495().b[3][0]++;
      cov_gan9kb495().s[15]++;
      firstButton.focus();
    } else {
      cov_gan9kb495().b[3][1]++;
    }
  };
  var toastOptions = (cov_gan9kb495().s[16]++, _objectSpread(_objectSpread({}, options === null || options === void 0 ? void 0 : options.toastOptions), {}, {
    autoClose: (cov_gan9kb495().b[4][0]++, options === null || options === void 0 || (_options$toastOptions = options.toastOptions) === null || _options$toastOptions === void 0 ? void 0 : _options$toastOptions.autoClose) || (cov_gan9kb495().b[4][1]++, false)
  }));
  cov_gan9kb495().s[17]++;
  toastId = (0, _reactToastify.toast)(function (_ref2) {
    var closeToast = _ref2.closeToast;
    cov_gan9kb495().f[5]++;
    cov_gan9kb495().s[18]++;
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, content, /*#__PURE__*/_react["default"].createElement(_core.Flex, {
      justifyContent: "flex-end"
    }, (cov_gan9kb495().b[5][0]++, options === null || options === void 0 ? void 0 : options.actions) && (cov_gan9kb495().b[5][1]++, options.actions.map(function (action, i) {
      cov_gan9kb495().f[6]++;
      cov_gan9kb495().s[19]++;
      return /*#__PURE__*/_react["default"].createElement(ToastButton, {
        key: i,
        actionText: action.actionText,
        onClick: action.onClick,
        analyticsName: "".concat(analyticsName, "-").concat(action.actionText.toLowerCase().split(' ').join('-')),
        "aria-label": action['aria-label'],
        trackImpression: options === null || options === void 0 ? void 0 : options.trackImpression
      });
    })), (cov_gan9kb495().b[6][0]++, !toastOptions.autoClose) && (cov_gan9kb495().b[6][1]++, /*#__PURE__*/_react["default"].createElement(ToastButton, {
      actionText: "Close",
      onClick: closeToast,
      analyticsName: "".concat(analyticsName, "-close"),
      "aria-label": 'aria-label' in toastOptions ? (cov_gan9kb495().b[7][0]++, toastOptions['aria-label']) : (cov_gan9kb495().b[7][1]++, ''),
      trackImpression: options === null || options === void 0 ? void 0 : options.trackImpression
    }))));
  }, _objectSpread({
    closeButton: false,
    // do not use the built-in Close button
    style: {
      backgroundColor: type === 'info' ? (cov_gan9kb495().b[8][0]++, _eero.colors.neutrals100) : (cov_gan9kb495().b[8][1]++, _eero.colors.red50),
      boxShadow: _eero.shadows.z2,
      color: _eero.colors.neutrals0,
      fontFamily: _eero.fonts.sans,
      fontSize: _eero.fontSizesNamedWithUnits.s1,
      fontWeight: _eero.fontWeights.normal,
      lineHeight: _eero.lineHeightsWithUnits.s1,
      margin: 0,
      paddingBlock: _eero.spaceWithUnits[5],
      paddingInline: _eero.spaceWithUnits[7]
    },
    onOpen: onOpen
  }, toastOptions));
};
var _default = exports["default"] = Toast;